// node_nodules
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "../setup";

// Define a service using a base URL and expected endpoints
export const foodStationApi = createApi({
  reducerPath: "foodStationApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["FoodStations"],
  endpoints: (builder) => ({
    getStationList: builder.query({
      query: (subDomain) => {
        return {
          url: `/station/list`,
          method: "GET",
          params: { subdomain: subDomain },
        };
      },
      providesTags: (result) => {
        return result
          ? [
              ...result.map(({ id }) => ({ type: "FoodStations", id })),
              { type: "FoodStations", id: "LIST" },
            ]
          : [{ type: "FoodStations", id: "LIST" }];
      },
    }),
    createStation: builder.mutation({
      query: ({ subdomain, data }) => {
        return {
          url: `/station/create`,
          method: "POST",
          body: { ...data, subdomain },
        };
      },
      invalidatesTags: [{ type: "FoodStations", id: "LIST" }],
    }),
    updateStation: builder.mutation({
      query: ({ id, subdomain, data }) => {
        return {
          url: `/station/${id}`,
          method: "PATCH",
          body: data,
          params: { subdomain: subdomain },
        };
      },
      invalidatesTags: [{ type: "FoodStations", id: "LIST" }],
    }),
    deleteStation: builder.mutation({
      query: ({ id, subdomain }) => {
        return {
          url: `/station/${id}`,
          method: "DELETE",
          params: { subdomain: subdomain },
        };
      },
      invalidatesTags: [{ type: "FoodStations", id: "LIST" }],
    }),
    uploadImage: builder.mutation({
      query: ({ id, subdomain, data }) => {
        const formData = new FormData();
        formData.append("file", data);
        return {
          url: `/station/image/upload/${id}`,
          method: "POST",
          body: formData,
          params: { subdomain: subdomain },
        };
      },
      invalidatesTags: [{ type: "FoodStations", id: "LIST" }],
    }),
    uploadSound: builder.mutation({
      query: ({ id, subdomain, data }) => {
        const formData = new FormData();
        formData.append("file", data);
        return {
          url: `/station/sound/upload/${id}`,
          method: "POST",
          body: formData,
          params: { subdomain: subdomain },
        };
      },
      invalidatesTags: [{ type: "FoodStations", id: "LIST" }],
    }),
  }),
});

export const {
  useGetStationListQuery,
  useCreateStationMutation,
  useUpdateStationMutation,
  useDeleteStationMutation,
  useUploadImageMutation,
  useUploadSoundMutation,
} = foodStationApi;
